import { render, staticRenderFns } from "./trauma.vue?vue&type=template&id=3a8adff6&scoped=true"
import script from "./trauma.vue?vue&type=script&lang=js"
export * from "./trauma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8adff6",
  null
  
)

export default component.exports